import { render, staticRenderFns } from "./UppyUploader.vue?vue&type=template&id=510d1d9f&scoped=true&"
import script from "./UppyUploader.vue?vue&type=script&lang=js&"
export * from "./UppyUploader.vue?vue&type=script&lang=js&"
import style0 from "./UppyUploader.vue?vue&type=style&index=0&id=510d1d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510d1d9f",
  null
  
)

export default component.exports